import { createSvgComponent } from "../../icon/createSvgComponent";
import StarLine from "@core/icon/assets/star-line.svg";
export default createSvgComponent(StarLine);